export const stripHtmlTags = (txt = '') => txt.replace(/<\/?\w+>/g, '');
